module.exports = __webpack_public_path__ + "static/img/pic6.a50745b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic6.jpg
// module id = tqii
// module chunks = 1